import { DbTable } from "./DbTable";
import { Company } from "../../models/company.model";
import { Injectable } from "@angular/core";

import { Customer } from '../../models/customer.model';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class DbCompanies extends DbTable<Company> {


      constructor(public _http: HttpClient)  {
          super(_http, "companies");
      }
    
}

@Injectable()
export class DbCustomers extends DbTable<Customer> {


      constructor(public _http: HttpClient)  {
          super(_http, "Customers");
      }
    
}